import { IGNORE_ERRORS } from '@cuemath/av';
import {
  OT_PACKAGE_SENTRY_ISSUE_LIST,
  IR_ISR_IGNORE_ERRORS,
  IR_ISR_DENY_URLS,
} from '@cuemath/intel';
import { init, configureScope, Integrations } from '@sentry/browser';
import {
  IN_HOUSE_AV_SENTRY_ISSUE_LIST,
  WEB_RTC_AV_SENTRY_ISSUE_LIST,
} from 'comps/webRTC/constant';
import { getUserIdFromCookie } from 'utils/auth';

import { isDev, isStaging, SENTRY_DSN } from '../../constants/api';

const userId = getUserIdFromCookie();

function canTrackErrors() {
  return !isDev;
}

export function setUser(id) {
  if (canTrackErrors()) {
    configureScope(scope => {
      scope.setUser({ id });
    });
  }
}

export function initSentry() {
  if (canTrackErrors()) {
    const envName = isStaging ? 'staging' : 'production';

    // https://github.com/getsentry/sentry-javascript/issues/3388
    const isAffectedByIssue3388 = navigator.userAgent.includes('Chrome/74.0.3729');

    init({
      dsn: SENTRY_DSN,
      denyUrls: [...IR_ISR_DENY_URLS],
      ignoreErrors: [
        ...IR_ISR_IGNORE_ERRORS,
        ...IN_HOUSE_AV_SENTRY_ISSUE_LIST,
        ...WEB_RTC_AV_SENTRY_ISSUE_LIST,
        ...OT_PACKAGE_SENTRY_ISSUE_LIST,
        ...IGNORE_ERRORS,
      ],
      release: `${envName}:${process.env.REACT_APP_SENTRY_RELEASE}`,
      environment: envName,
      integrations: [
        new Integrations.TryCatch({
          requestAnimationFrame: !isAffectedByIssue3388,
        }),
      ],
    });

    setUser(userId || null);

    if (isStaging) {
      configureScope(scope => {
        scope.setTag('sub-domain', window.location.hostname.split('.')[0].split('-')[0]);
      });
    }
  }
}
